import gql from 'graphql-tag'

export default gql`mutation setPassword($id:String!,$password:String!){
    setPassword(_id:$id,password:$password){
      _id
    }
  }`
